import { SUPABASE_AUTH_STORAGE_KEY } from '@pairo/shared';
import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.error(
    'Supabase env değişkenleri eksik: VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY (.env dosyasını kontrol et)',
  );
}

// Adresten türetilen varsayılan yerine SABİT anahtar — backend adresi değişince
// admin oturumu düşmesin (bkz. shared/src/constants/authStorageKey.ts).
export const supabase = createClient(url, anonKey, {
  auth: { storageKey: SUPABASE_AUTH_STORAGE_KEY },
});
